import AT from '../../actionTypes'

const initialState = []

export default function closingTasks(state = initialState, action) {
  const { type, payload } = action
  switch (type) {
    case AT.SET_CLOSINGS_TASK:
      return payload
    default:
      return state
  }
}
